(function() {
  const LINE_SPACING_BASE = 1.2;
  const PX_TO_CM = 2.54 / 96;
  const CM_TO_PX = 96 / 2.54; // aktuell nur für evtl. spätere Berechnungen
  const MIN_LINE_HEIGHT_CM = 1.5;
  const MAX_WIDTH_CM = 210;
  const MAX_HEIGHT_CM = 110;

  // wird aus #base_font_size geholt
  let baseFontSize = 80;

  const MAX_LINES = 3; // maximal 3 Zeilen

  let FONT_CONFIG = {};
  let loadedFonts = {};
  let currentFontName = null;

  let lines = [];
  let draw;

  let desiredWidthCm = null;
  let desiredHeightCm = null;
  let lastEdited = null; // 'width' oder 'height'
  let updatingInputs = false;

  // globale Farbe für alle Zeilen + Motiv
  let globalColor = '#000000';

  // Motiv-Masse aus Hidden-Inputs (px)
  let motifWidthPx = null;
  let motifHeightPx = null;

  // Basis-Min-Höhe aus #min_height (cm)
  let baseMinHeightCm = null;

  // Referenz auf Button, damit wir den Zustand updaten können
  let addLineBtnRef = null;

  // Basis-Abstand (CSS margin-top) von #text-preview → Motiv
  let baseTextMarginTop = 0;

  document.addEventListener('DOMContentLoaded', function() {
    const svgEl = document.getElementById('text-preview');
    const addLineBtn = document.getElementById('add-line-btn');
    const widthInput = document.getElementById('target-width-cm');
    const heightInput = document.getElementById('target-height-cm');

    addLineBtnRef = addLineBtn;

    // BASE_FONT_SIZE aus Hidden-Input holen
    const baseFontInput = document.getElementById('base_font_size');
    if (baseFontInput) {
      const raw = (baseFontInput.value || '').toString().replace(',', '.');
      const v = parseFloat(raw);
      if (!isNaN(v) && v > 0) {
        baseFontSize = v;
      }
    }

    // Basis-Min-Höhe aus #min_height (cm)
    const minHeightInput = document.getElementById('min_height');
    if (minHeightInput) {
      const raw = (minHeightInput.value || '').toString().replace(',', '.');
      const v = parseFloat(raw);
      if (!isNaN(v) && v > 0) {
        baseMinHeightCm = v;
      }
    }

    // Basis margin-top merken (aktueller Abstand Motiv ↔ Text)
    if (svgEl) {
      const cs = getComputedStyle(svgEl);
      baseTextMarginTop = parseFloat(cs.marginTop) || 0;
    }

    // Motiv-Masse aus Hidden-Inputs holen
    const svgPathWidthInput = document.getElementById('svg_path_width');
    const svgPathHeightInput = document.getElementById('svg_path_height');
    if (svgPathWidthInput) {
      motifWidthPx = parseFloat(svgPathWidthInput.value.replace(',', '.')) || null;
    }
    if (svgPathHeightInput) {
      motifHeightPx = parseFloat(svgPathHeightInput.value.replace(',', '.')) || null;
    }

    // Globaler Farbeingab (einmal für alles)
const globalColorInput = document.querySelector('.wunschtext-line-color-input');
if (globalColorInput) {
  // 🔥 Farbe aus dem Attribut `color-value` holen (fallback auf value / schwarz)
  const initialColor =
    globalColorInput.getAttribute('color-value') ||
    globalColorInput.value ||
    '#000000';

  globalColor = initialColor;
  applyColorToMotif(); // initial auf Motiv anwenden

  globalColorInput.addEventListener('change', function(e) {
    // bei jeder Änderung wieder aus `color-value` lesen
    const colorFromAttr =
      e.target.getAttribute('color-value') ||
      '#000000';

    globalColor = colorFromAttr;

    // alle vorhandenen Zeilen auf neue Farbe setzen
    lines.forEach(function(line) {
      line.color = globalColor;
    });

    applyColorToMotif(); // Motiv einfärben
    renderPreview();
  });
}


    if (!svgEl || !addLineBtn) {
      console.warn('[Wunschtext] SVG oder Buttons nicht gefunden – Script beendet.');
      return;
    }

    draw = SVG(svgEl);

    initFontConfigAndLoad();

    addLineBtn.addEventListener('click', function() {
      if (lines.length >= MAX_LINES) {
        return;
      }
      addLine();
    });

    // Breite/Höhe: nur bei change/blur übernehmen (immer proportional!)
    function attachSizeHandler(input, kind) {
      ['change', 'blur'].forEach(function(evt) {
        input.addEventListener(evt, function() {
          if (updatingInputs) return;

          const raw = (input.value || '').toString().replace(',', '.');
          const v = parseFloat(raw);

          if (kind === 'width') {
            desiredWidthCm = isNaN(v) ? null : v;
            lastEdited = 'width';
          } else {
            desiredHeightCm = isNaN(v) ? null : v;
            lastEdited = 'height';
          }

          renderPreview();
        });
      });
    }

    if (widthInput)  attachSizeHandler(widthInput,  'width');
    if (heightInput) attachSizeHandler(heightInput, 'height');

    // Plus/Minus Buttons
    document.querySelectorAll('.size-step-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const targetKind = btn.dataset.target;
        const dir = btn.dataset.dir === '-' ? -1 : 1;
        const input = targetKind === 'width' ? widthInput : heightInput;
        if (!input) return;

        const step = parseFloat(input.step) || 0.1;
        const raw = (input.value || '').toString().replace(',', '.');
        let cur = parseFloat(raw);
        if (isNaN(cur)) cur = 0;

        cur = cur + dir * step;

        if (input.min !== '') cur = Math.max(cur, parseFloat(input.min));
        if (input.max !== '') cur = Math.min(cur, parseFloat(input.max));

        input.value = cur.toFixed(1);

        const ev = new Event('change', { bubbles: true });
        input.dispatchEvent(ev);
      });
    });

    // erste Standardzeile (Text kommt später aus data-text)
    addLine({
      text: null,
      sizePercent: 100,
      color: globalColor,
      align: 'center',
      fontName: currentFontName
    });

    updateAddLineButtonState();
  });

  function initFontConfigAndLoad() {
    const select = document.getElementById('font-select');
    if (!select) return;

    Array.from(select.options).forEach(function(opt) {
      const name = opt.value;
      const url = opt.dataset.font;
      if (name && url) {
        FONT_CONFIG[name] = url;
      }
    });

    currentFontName = select.value || Object.keys(FONT_CONFIG)[0];

    Object.entries(FONT_CONFIG).forEach(function([name, url]) {
      opentype.load(url, function(err, font) {
        if (err) {
          console.error('[Wunschtext] Font konnte nicht geladen werden:', name, err);
          return;
        }
        loadedFonts[name] = font;
        renderPreview();
      });
    });
  }

  // Motiv-SVG (#svg-path) einfärben
  function applyColorToMotif() {
    const svgMotif = document.getElementById('svg-path');
    if (!svgMotif) return;

    const elems = svgMotif.querySelectorAll('path, rect, circle, ellipse, polygon, polyline, line');
    elems.forEach(function(el) {
      el.setAttribute('fill', globalColor);
      el.setAttribute('stroke', globalColor);
    });
  }

  // Button-State je nach Anzahl Zeilen updaten
  function updateAddLineButtonState() {
    if (!addLineBtnRef) return;

    if (lines.length >= MAX_LINES) {
      addLineBtnRef.classList.add('is-disabled');
      addLineBtnRef.style.opacity = '0.5';
      addLineBtnRef.style.pointerEvents = 'none';
      addLineBtnRef.setAttribute('aria-disabled', 'true');
    } else {
      addLineBtnRef.classList.remove('is-disabled');
      addLineBtnRef.style.opacity = '';
      addLineBtnRef.style.pointerEvents = '';
      addLineBtnRef.removeAttribute('aria-disabled');
    }
  }

  // nur eine Zeile bekommt "default"
  function updateDefaultClass() {
    const container = document.getElementById('lines-container');
    if (!container) return;

    const items = container.querySelectorAll('.line-control');

    items.forEach(function(el) {
      el.classList.remove('default');
    });

    if (items.length === 1) {
      const el = items[0];
      el.classList.add('default');

      const sizeInput = el.querySelector('.wunschtext-line-size-input');
      if (sizeInput) {
        sizeInput.value = '100';

        const lineId = el.dataset.lineId;
        const lineObj = lines.find(function(l) { return l.id === lineId; });
        if (lineObj) {
          lineObj.sizePercent = 100;
        }

        const sizeHeaderText = el.querySelector('.dynamic-select-size .dynamic-select-header .dynamic-select-option-text');
        if (sizeHeaderText) {
          sizeHeaderText.textContent = '100%';
        }
      }
    }
  }

  // Namen der Line-Item-Properties pro Zeile neu durchnummerieren
  function renumberLinePropertyNames() {
    const container = document.getElementById('lines-container');
    if (!container) return;

    const items = container.querySelectorAll('.line-control');

    items.forEach(function(el, index) {
      const n = index + 1; // Text1, Text2, ...

      const textInput  = el.querySelector('.wunschtext-line-text');
      const fontInput  = el.querySelector('.wunschtext-line-font-input');
      const colorInput = el.querySelector('.wunschtext-line-color-input');
      const stepLabel  = el.querySelector('.line-control-step');

      if (stepLabel) {
        stepLabel.textContent = 'Zeile ' + n;
      }

      if (textInput) {
        textInput.name = 'properties[Text' + n + ']';
      }
      if (fontInput) {
        fontInput.name = 'properties[Schrifart' + n + ']';
      }
      if (colorInput) {
        colorInput.name = 'properties[Folienfarbe' + n + ']';
      }
    });
  }

  function addLine(initial) {
    if (lines.length >= MAX_LINES) {
      updateAddLineButtonState();
      return;
    }

    initial = initial || {};

    const id = Date.now().toString() + Math.random().toString(16).slice(2);

    const line = {
      id: id,
      text: typeof initial.text === 'string' ? initial.text : null,
      sizePercent: typeof initial.sizePercent === 'number' ? initial.sizePercent : 100,
      color: typeof initial.color === 'string' ? initial.color : globalColor || '#000000',
      align: initial.align || 'center',
      fontName: initial.fontName || currentFontName || Object.keys(FONT_CONFIG)[0],
      spacing: initial.spacing || 1.0
    };

    lines.push(line);
    renderLineControls(line);
    renderPreview();
    updateAddLineButtonState();
  }

  function renderLineControls(line) {
    const container = document.getElementById('lines-container');
    const template = document.getElementById('line-template');
    if (!container || !template) return;

    const fragment = template.content.cloneNode(true);
    const wrapper = fragment.querySelector('.line-control');
    if (!wrapper) return;

    wrapper.dataset.lineId = line.id;

    const textInput    = wrapper.querySelector('.wunschtext-line-text');
    const fontInput    = wrapper.querySelector('.wunschtext-line-font-input');
    const sizeInput    = wrapper.querySelector('.wunschtext-line-size-input');
    const alignInput   = wrapper.querySelector('.wunschtext-line-align-input');
    const spacingInput = wrapper.querySelector('.wunschtext-line-spacing-input');
    const removeBtn    = wrapper.querySelector('.wunschtext-line-remove');

    // TEXT (Default aus data-text)
    if (textInput) {
      const dataDefault = textInput.dataset.text || '';
      if (line.text == null || line.text === '') {
        line.text = dataDefault;
      }
      textInput.value = line.text;

      textInput.addEventListener('input', function(e) {
        line.text = e.target.value;
        renderPreview();
      });
    }

    // FONT
    if (fontInput) {
      if (!fontInput.value) {
        fontInput.value = line.fontName;
      } else {
        line.fontName = fontInput.value;
      }

      fontInput.addEventListener('change', function(e) {
        line.fontName = e.target.value || currentFontName;
        renderPreview();
      });
    }

    // SIZE (Prozent)
    if (sizeInput) {
      if (sizeInput.value) {
        let v = parseFloat(sizeInput.value);
        if (!isNaN(v)) line.sizePercent = v;
      } else {
        sizeInput.value = String(line.sizePercent);
      }

      sizeInput.addEventListener('change', function(e) {
        let v = parseFloat(e.target.value);
        if (isNaN(v)) v = 100;
        line.sizePercent = v;
        renderPreview();
      });
    }

    // ALIGN
    if (alignInput) {
      if (alignInput.value) {
        line.align = alignInput.value;
      } else {
        alignInput.value = line.align;
      }

      alignInput.addEventListener('change', function(e) {
        line.align = e.target.value || 'center';
        renderPreview();
      });
    }

    // SPACING
    if (spacingInput) {
      if (spacingInput.value) {
        let v = parseFloat(spacingInput.value);
        if (!isNaN(v)) line.spacing = v;
      } else {
        spacingInput.value = line.spacing.toFixed(1);
      }

      spacingInput.addEventListener('change', function(e) {
        let v = parseFloat((e.target.value || '').replace(',', '.'));
        if (isNaN(v)) v = 1.0;
        if (v < 0.5) v = 0.5;
        if (v > 2.5) v = 2.5;
        line.spacing = v;
        renderPreview();
      });
    }

    // REMOVE
    if (removeBtn) {
      removeBtn.addEventListener('click', function() {
        lines = lines.filter(function(l) { return l.id !== line.id; });
        wrapper.remove();

        renumberLinePropertyNames();
        updateDefaultClass();
        renderPreview();
        updateAddLineButtonState();
      });
    }

    container.appendChild(fragment);

    renumberLinePropertyNames();
    updateDefaultClass();

    if (window.initAllDynamicSelects) {
      window.initAllDynamicSelects(wrapper);
    }

    updateAddLineButtonState();
  }

  function transformPath(path, scale, dx, dy) {
    const commands = path.commands || [];
    commands.forEach(function(cmd) {
      if ('x'  in cmd) cmd.x  = cmd.x * scale  + dx;
      if ('y'  in cmd) cmd.y  = cmd.y * scale  + dy;
      if ('x1' in cmd) cmd.x1 = cmd.x1 * scale + dx;
      if ('y1' in cmd) cmd.y1 = cmd.y1 * scale + dy;
      if ('x2' in cmd) cmd.x2 = cmd.x2 * scale + dx;
      if ('y2' in cmd) cmd.y2 = cmd.y2 * scale + dy;
    });
  }

  function renderPreview() {
    if (!draw) return;

    draw.clear();

    if (!lines.length) {
      draw.viewbox(0, 0, 10, 10);
      updateSizeInfo(null, null);
      return;
    }

    const tempEntries = [];
    let maxWidthText = 0;

    // 1) Pfade erzeugen, BoundingBoxen sammeln (nur Text)
    lines.forEach(function(line) {
      const text = line.text || ' ';
      const fontName = line.fontName || currentFontName;
      const font = loadedFonts[fontName];
      if (!font) return;

      const sizePercent = typeof line.sizePercent === 'number' ? line.sizePercent : 100;
      const fontSize = baseFontSize * (sizePercent / 100);

      const path = font.getPath(text, 0, 0, fontSize);
      const bb = path.getBoundingBox();
      const lineHeightPx = (bb.y2 - bb.y1) || fontSize;

      const width = bb.x2 - bb.x1;
      if (width > maxWidthText) maxWidthText = width;

      tempEntries.push({
        path,
        bb,
        lineHeightPx,
        color: line.color,
        align: line.align || 'center',
        spacing: line.spacing || 1.0
      });
    });

    if (!tempEntries.length || maxWidthText <= 0) {
      draw.viewbox(0, 0, 10, 10);
      updateSizeInfo(null, null);
      return;
    }

    // 2) Zeilen ausrichten (Text)
    const pathEntries = [];
    let currentY = 0;
    let prevLineHeightPx = 0;

    const refLeft = 0;
    const refRight = maxWidthText;
    const refCenter = maxWidthText / 2;

    tempEntries.forEach(function(entry, index) {
      const { path, bb, lineHeightPx, color, align, spacing } = entry;

      if (index === 0) {
        currentY = 0;
      } else {
        const spaceFactor = (typeof spacing === 'number' && !isNaN(spacing)) ? spacing : 1.0;
        currentY += prevLineHeightPx * LINE_SPACING_BASE * spaceFactor;
      }

      prevLineHeightPx = lineHeightPx;

      const lineLeft = bb.x1;
      const lineRight = bb.x2;
      const lineCenter = (bb.x1 + bb.x2) / 2;

      let shiftX = 0;
      if (align === 'left') {
        shiftX = refLeft - lineLeft;
      } else if (align === 'right') {
        shiftX = refRight - lineRight;
      } else {
        shiftX = refCenter - lineCenter;
      }

      const shiftY = currentY - bb.y1;

      const commands = path.commands || [];
      commands.forEach(function(cmd) {
        if ('x' in cmd)  cmd.x  += shiftX;
        if ('y' in cmd)  cmd.y  += shiftY;
        if ('x1' in cmd) cmd.x1 += shiftX;
        if ('y1' in cmd) cmd.y1 += shiftY;
        if ('x2' in cmd) cmd.x2 += shiftX;
        if ('y2' in cmd) cmd.y2 += shiftY;
      });

      pathEntries.push({ path, color });
    });

    // 3) BoundingBox nur für Text (für Preview-SVG)
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    pathEntries.forEach(function(entry) {
      const bb = entry.path.getBoundingBox();
      if (bb.x1 < minX) minX = bb.x1;
      if (bb.y1 < minY) minY = bb.y1;
      if (bb.x2 > maxX) maxX = bb.x2;
      if (bb.y2 > maxY) maxY = bb.y2;
    });

    const rawTextWidthPx  = maxX - minX;
    const rawTextHeightPx = maxY - minY;

    // 4) Preview-Skalierung (Text + Motiv gemeinsam)
    let previewScale = 1;
    const PREVIEW_MAX_W = 400; // entspricht max-width der .svg-size Box
    const PREVIEW_MAX_H = 600;

    if (rawTextWidthPx > 0 && rawTextHeightPx > 0) {
      const combinedWidthPx  = motifWidthPx ? Math.max(rawTextWidthPx, motifWidthPx) : rawTextWidthPx;
      const combinedHeightPx = rawTextHeightPx + (motifHeightPx || 0);

      const sx = PREVIEW_MAX_W / combinedWidthPx;
      const sy = PREVIEW_MAX_H / combinedHeightPx;
      previewScale = Math.min(sx, sy, 1);
    }

    const widthScaledText  = rawTextWidthPx  * previewScale;
    const heightScaledText = rawTextHeightPx * previewScale;

    const offsetX = -(minX * previewScale);
    const offsetY = -(minY * previewScale);

    const group = draw.group();
    pathEntries.forEach(function(entry) {
      transformPath(entry.path, previewScale, offsetX, offsetY);
      const d = entry.path.toPathData(2);
      group.path(d).fill(entry.color || '#000000');
    });

    draw.viewbox(0, 0, widthScaledText, heightScaledText);

    const svgEl = document.getElementById('text-preview');
    if (svgEl) {
      svgEl.setAttribute('width', widthScaledText);
      svgEl.setAttribute('height', heightScaledText);

      // Abstand Motiv ↔ erste Textzeile über spacing der ersten Zeile steuern
      const firstEntry = tempEntries[0];
      const firstLineObj = lines[0];

      if (firstEntry && firstLineObj) {
        const spacingFactor = firstLineObj.spacing || 1.0;
        const extraGapPx = (spacingFactor - 1) * firstEntry.lineHeightPx * previewScale;
        const newMargin = baseTextMarginTop + extraGapPx;
        svgEl.style.marginTop = newMargin.toFixed(1) + 'px';
      } else {
        svgEl.style.marginTop = baseTextMarginTop + 'px';
      }
    }

    // Motiv-SVG in gleicher Scale mitziehen (Breite/Höhe neu setzen)
    const svgMotif = document.getElementById('svg-path');
    if (svgMotif && motifWidthPx && motifHeightPx) {
      const scaledMotifWidth  = motifWidthPx  * previewScale;
      const scaledMotifHeight = motifHeightPx * previewScale;

      svgMotif.setAttribute('width',  scaledMotifWidth);
      svgMotif.setAttribute('height', scaledMotifHeight);
      svgMotif.style.width  = scaledMotifWidth  + 'px';
      svgMotif.style.height = scaledMotifHeight + 'px';
    }

    // 5) cm-Grösse aus echter Vorschau (Container .svg-size)
    const container = document.querySelector('.svg-size');
    if (!container) {
      updateSizeInfo(null, null);
      return;
    }

    const rect = container.getBoundingClientRect();

    let rawWidthCm  = rect.width  * PX_TO_CM;
    let rawHeightCm = rect.height * PX_TO_CM;

    if (!(rawWidthCm > 0 && rawHeightCm > 0)) {
      updateSizeInfo(null, null);
      return;
    }

    // physische Sticker-Grösse → SCALE, immer proportional
    let scale = 1;

    if (lastEdited === 'width' && desiredWidthCm && desiredWidthCm > 0) {
      scale = desiredWidthCm / rawWidthCm;
    } else if (lastEdited === 'height' && desiredHeightCm && desiredHeightCm > 0) {
      scale = desiredHeightCm / rawHeightCm;
    } else if (desiredWidthCm && desiredWidthCm > 0) {
      scale = desiredWidthCm / rawWidthCm;
    } else if (desiredHeightCm && desiredHeightCm > 0) {
      scale = desiredHeightCm / rawHeightCm;
    }

    // Mindesthöhe über #min_height + 1.5 cm pro zusätzlicher Zeile
    let minTotalHeightCm;
    if (baseMinHeightCm != null) {
      const extraPerLineCm = 1.5;
      const extraLines = Math.max(0, lines.length - 1);
      minTotalHeightCm = baseMinHeightCm + extraLines * extraPerLineCm;
    } else {
      minTotalHeightCm = lines.length * MIN_LINE_HEIGHT_CM;
    }

    let minScale = 0;
    if (minTotalHeightCm > 0) {
      minScale = minTotalHeightCm / rawHeightCm;
    }

    let maxScaleWidth  = MAX_WIDTH_CM  / rawWidthCm;
    let maxScaleHeight = MAX_HEIGHT_CM / rawHeightCm;
    let maxScale = Math.min(maxScaleWidth, maxScaleHeight);
    if (!isFinite(maxScale) || maxScale <= 0) maxScale = Infinity;

    if (scale <= 0 || !isFinite(scale)) scale = 1;
    if (scale < minScale) scale = minScale;
    if (scale > maxScale) scale = maxScale;

    const finalWidthCm  = rawWidthCm  * scale;
    const finalHeightCm = rawHeightCm * scale;

    syncSizeInputs(finalWidthCm, finalHeightCm);
    updateSizeInfo(finalWidthCm, finalHeightCm);
  }

  function syncSizeInputs(wCm, hCm) {
    const widthInput = document.getElementById('target-width-cm');
    const heightInput = document.getElementById('target-height-cm');
    if (!widthInput || !heightInput || !wCm || !hCm) return;

    updatingInputs = true;
    widthInput.value = wCm.toFixed(1);
    heightInput.value = hCm.toFixed(1);
    desiredWidthCm = wCm;
    desiredHeightCm = hCm;
    updatingInputs = false;
  }

  function updateSizeInfo(wCm, hCm) {
    const el = document.getElementById('size-info');
    if (!el || !wCm || !hCm) {
      if (el) el.textContent = '–';
      return;
    }
    el.textContent = wCm.toFixed(1) + ' × ' + hCm.toFixed(1) + ' cm';
  }
})();
